import { getZrmUserInfo, type ZrmClickstreamUser } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';

// https://dataportal.zillowgroup.net/event-registry/6104
export const emitSubmitWidgetSupportRequestEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '6104',
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zram_all',
      trigger_source_nm: 'submit_button_support_widget',
      trigger_location_nm: 'support_widget',
    },
    semantic: {
      semantic_event_nm: 'submit_from_support_widget',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

//https://dataportal.zillowgroup.net/event-registry/6855
export const emitOpenSupportWidgetEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '6855',
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'zram_all',
      trigger_source_nm: 'support_widget_click',
      trigger_location_nm: 'support_widget',
    },
    semantic: {
      semantic_event_nm: 'user_click_support_widget',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });
